module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": _vm.ctx + '/static/images/header/' + _vm.websitename + '/header.jpg'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "heading"
  }, [(_vm.h1) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "icon"
  }, [_vm._v(_vm._s(_vm.icon))]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.h1))]), _vm._v(" "), (_vm.logindata == 'true') ? _c('p', [(_vm.userrole == 'B') ? _c('span', [_vm._v("Ingelogd als " + _vm._s(_vm.username) + " ")]) : _vm._e(), _vm._v(" "), (_vm.userrole != 'B') ? _c('span', [_vm._v("Welkom " + _vm._s(_vm.username) + " ")]) : _vm._e(), _c('br'), _vm._v(" "), (_vm.lastlogin) ? _c('span', [_c('span', [_vm._v("Vorig bezoek: " + _vm._s(_vm.lastlogin))]), _c('span', {
    staticClass: "hour"
  }, [_vm._v(" uur")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.subtitle) ? _c('p', [_vm._v(_vm._s(_vm.subtitle))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.produkttypenaam) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    class: 'icon icon-' + _vm.produkttypenaam
  }), _vm._v(" "), (_vm.produktnaam == 'Aansprakelijkheid') ? _c('h1', [_vm._v(_vm._s(_vm.produktnaam) + "sverzekering")]) : _c('h1', [_vm._v(_vm._s(_vm.produktnaam) + "verzekering")]), _vm._v(" "), _c('p', [_vm._v("Mijn polisnummer: " + _vm._s(_vm.polisnummer) + " ")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e09b1ac"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/components/banner.vue
// module id = 127
// module chunks = 0